export default __webpack_public_path__ + "static/media/express-js.63afed20.svg";